import {
  RowDataReducerActionPayload,
  RowDataReducerState,
} from "../../../types";

export const addSchemaPropertyAction = (
  payload: Partial<RowDataReducerActionPayload>,
  state: RowDataReducerState,
): RowDataReducerState => {
  const { newPropertyKey, newProperty } = payload;
  if (!newPropertyKey || !newProperty) return state;

  const updatedSchema = {
    ...state.schema,
    properties: {
      ...state.schema.properties,
      [newPropertyKey]: newProperty,
    },
  };

  return {
    ...state,
    schema: updatedSchema,
  };
};
